import axios from "axios";
const channelsUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/channels`;
const channelsPricingUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/channels-pricing`;
const salesPointsUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/sales-points`;
const sellerSalesPointsUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/seller-sales-points`;
const validateTokenUrl = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/link-sale`;
const saleUrl = `${process.env.REACT_APP_BASE_URL}/services/userprofile/api/link-sale`;

function urlManager(url = null, product = null) {
  if (url !== null){
    let urlManager = url
    if (product !== null) {
      urlManager = `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services${urlManager.split('/services').pop()}`
    }
    return urlManager
  }
}

export const getChannels = async (token) => {
  return await axios
    .get(channelsUrl, { headers: { authorization: `Bearer ${token}` } })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};
export const postChannels = async (token, data,displayError) => {
  return await axios
    .post(`${urlManager(channelsUrl,'mediline')}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const putChannels = async (token, channelId, data,displayError) => {
  return await axios
    .put(`${urlManager(channelsUrl,'mediline')}/${channelId}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const deleteChannels = async (token, channelId,displayError) => {
  return await axios
    .delete(`${urlManager(channelsUrl, 'mediline')}/${channelId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const getSalesPoints = async (token, channelId) => {
  return await axios
    .get(`${salesPointsUrl}/${channelId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const postSalesPoints = async (token, data,displayError) => {
  return await axios
    .post(`${urlManager(salesPointsUrl,'mediline')}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const putSalesPoint = async (token, salesPointId, data,displayError) => {
  return await axios
    .put(`${urlManager(salesPointsUrl,'mediline')}/${salesPointId}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const deleteSalesPoints = async (token, salesPointId,displayError) => {
  return await axios
    .delete(`${urlManager(salesPointsUrl, 'mediline')}/${salesPointId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};

export const getSellerSalesPoints = async (token, channelId) => {
  return await axios
    .get(`${sellerSalesPointsUrl}/${channelId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const getSellerBySalesPoints = async (token, salesPointsId) => {
  return await axios
    .get(`${sellerSalesPointsUrl}/?salesPointId=${salesPointsId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error(error);
    });
};

export const postSellerSalesPoints = async (token, data, displayError) => {
  return await axios
    .post(`${urlManager(sellerSalesPointsUrl, 'mediline')}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError(((error.response?.data).toString()).toString());
    });
};
export const putSellerSalesPoints = async (token, sellerId, data,displayError) => {
  return await axios
    .put(`${urlManager(sellerSalesPointsUrl, 'mediline')}/${sellerId}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError(((error.response?.data).toString()).toString());
    });
};
export const deleteSellerSalesPoints = async (token, sellerId,displayError) => {
  return await axios
    .delete(`${urlManager(sellerSalesPointsUrl, 'mediline')}/${sellerId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError(((error.response?.data).toString()).toString());
    });
};

export const postSale = async (token,data, displayError) => {
  return await axios
    .post(`${urlManager(saleUrl,'mediline')}/${token}`, data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const validateToken = async (token, displayError) => {
  return await axios
    .get(`${validateTokenUrl}/validate-token?sellerToken=${token}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};


export const postChannelsPricing = async (token, channelId, data,displayError) => {
  return await axios
    .post(`${urlManager(channelsPricingUrl,'mediline')}/${channelId}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const putChannelsPricing = async (token, channelId, data,displayError) => {
  return await axios
    .put(`${urlManager(channelsPricingUrl,'mediline')}/${channelId}`, data, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};
export const getChannelsPricing = async (token, channelId,displayError) => {
  return await axios
    .get(`${channelsPricingUrl}/${channelId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};

export const deleteChannelsPricing = async (token, channelId,displayError) => {
  return await axios
    .delete(`${urlManager(channelsPricingUrl,'mediline')}/${channelId}`, {
      headers: { authorization: `Bearer ${token}` },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error((error.response?.data).toString());
      displayError((error.response?.data).toString());
    });
};